import React, { useState, useEffect } from "react";
import { Link, useHistory } from 'react-router-dom';
import { Table, Modal } from 'react-bootstrap';

import btcicon from "../../../icons/crypto/btc.svg";
import ethicon from "../../../icons/crypto/eth.svg";
import usdticon from "../../../icons/crypto/usdt.svg";
import usdcicon from "../../../icons/crypto/usdc.svg";

import { useTranslation } from "react-i18next";
import Loader from '../../pages/Loader';
import axios from 'axios';
import validator from 'validator';
import Snackbars from '../../pages/Snackbars';
import { checkauhtoken } from '../../../api/PrePageLoad';

export const Wallets_Withdrawal_Transaction = () => {

    const { t } = useTranslation();
    const history = useHistory();
    const [TransactionPreview, setTransactionPreview] = useState(false);
    const [loader, setLoader] = useState(false);
    const [error, setError] = useState(false);
    const [error_msg, setErrorMsg] = useState("");
    const [success, setSuccess] = useState(false);
    const [success_msg, setSuccessMsg] = useState("");

    const [cypto_wallet_id, setcypto_wallet_id] = useState("");
    const [account_id, setaccount_id] = useState("");
    const [withaddress, setwithaddress] = useState("");

    const [coincode, setCoincode] = useState("");
    const [coinname, setCoinname] = useState("");
    const [icon, setIcon] = useState(0);
    const [total, setTotal] = useState(0);
    const [available, setAvailable] = useState(0);

    const [withamount, setWithamount] = useState("");
    const [withamount_error, setWithamount_error] = useState("");

    const [networkchain, setnetworkchain] = useState("ERC20");
    const [networkchain_error, setnetworkchain_error] = useState("");

    const [google_auth, setgoogle_auth] = useState("");
    const [google_auth_error, setgoogle_auth_error] = useState("");
    const [OTPVerification, setOTPVerification] = useState(false);
    const [displaynote, setdisplaynote] = useState("");

    const [minamount, setminamount] = useState("");
    const [maxamount, setmaxamount] = useState("");
    const [feeamount, setfeeamount] = useState("");
    const [isfixed, setisfixed] = useState(true);
    const [usdamount, setusdamount] = useState("");
    const [euramount, seteuramount] = useState("");

    const [display_usdamount, setdisplay_usdamount] = useState(0);
    const [display_euramount, setdisplay_euramount] = useState(0);


    const [SMSOTPVerification, setSMSOTPVerification] = useState(false);
    const [transferotp, settransferotp] = useState("");
    const [transferotpmessage, settransferotpmessage] = useState("");
    const [transferotpmessage_error, settransferotpmessage_error] = useState("");

    const [TransferAccept, setTransferAccept] = useState(false);
    const [TransferDecline, setTransferDecline] = useState(false);
    const [success_display_amount, setsuccess_display_amount] = useState("");
    const [success_display_refno, setsuccess_display_refno] = useState("");
    const [success_display_toaccount, setsuccess_display_toaccount] = useState("");
    const [success_display_debitamount, setsuccess_display_debitamount] = useState("");
    
    const [success_display_details, setsuccess_display_details] = useState("");

    const [error_display_details, seterror_display_details] = useState("");
    const [error_display_amount, seterror_display_amount] = useState("");
    const [buy_select_value, setbuy_select_value] = useState(0);
    const [buy_debit_amount, setbuy_debit_amount] = useState(0);
    const [buy_credit_currency, setbuy_credit_currency] = useState(0);
    const [buy_debit_currency, setbuy_debit_currency] = useState(0);
    const [buy_select_fee, setbuy_select_fee] = useState(0);
    
    useEffect(() => {
        const walletId = window.localStorage.getItem("cypto_wallet_id");

        // Utility function to check if a value is empty
        const isEmpty = (value) => !value || value === "";

        checkauhtoken();

        if (isEmpty(walletId)) {
            history.push("/crypto");
        } else {
            handleLoad();
        }
        
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getbuylimit = (crypto_coin) => {
        let jsonpar = {
            coinname: "USD",
        }
        const headers = {
            'Content-Type': 'application/json',
            'useraccesstoken': process.env.REACT_APP_USER_ACCESS_TOKEN,
            'userauthtoken': 'Bearer ' + window.sessionStorage.getItem("user_jwt"),
        }
        setLoader(true);
        axios.post(process.env.REACT_APP_API_URL + 'limits/getbaselimit', jsonpar, { headers: headers })
            .then(function (res) {
                res = res.data;
                if (res.code === "200") {
                        // let cryptocoin = "BTC"
                        // allcrypto.forEach(element => {
                        //     if (element.coin_code === cryptocoinid) {
                        //         cryptocoin = element.coin_code
                        //     }
                        // });
                        const pair = `${crypto_coin}_USD`;

                        setminamount((res.minwithdrawcryptolimit / res.cryptoexchangerates[pair].last_price).toFixed(8));
                        setmaxamount((res.maxwithdrawcryptolimit / res.cryptoexchangerates[pair].last_price).toFixed(8));
            
                    setLoader(false);
                } else {
                    setLoader(false);
                }
            })
            .catch(function (error) {
                setLoader(false);
            });
    }


    const handleLoad = () => {
        setcypto_wallet_id(window.localStorage.getItem("cypto_wallet_id"));
        // setaccount_id(window.localStorage.getItem("account_id"));
        setwithaddress(window.localStorage.getItem("withaddress"));
        setLoader(true);
        let jsonpar = {
            crypto_wallet_id: window.localStorage.getItem("cypto_wallet_id"),
            // account_id: window.localStorage.getItem("account_id"),
            withaddress: window.localStorage.getItem("withaddress")
        }
        const headers = {
            'Content-Type': 'application/json',
            'useraccesstoken': process.env.REACT_APP_USER_ACCESS_TOKEN,
            'userauthtoken': 'Bearer ' + window.sessionStorage.getItem("user_jwt"),
        }

        axios.post(process.env.REACT_APP_API_URL + 'cryptoexchange/GetWithdrawDetails', jsonpar, { headers: headers })
            .then(function (res) {
                res = res.data;
                window.localStorage.removeItem("cypto_wallet_id");
                window.localStorage.removeItem("account_id");
                window.localStorage.removeItem("withaddress");
                if (res.code === "200") {
                    settransferotp(res.data.otp);
                    setLoader(false);
                    if (res.data.coincode === "BTC") {
                        setnetworkchain("BTC");
                        setCoinname("Bitcoin");
                        setIcon(btcicon);
                    } else if (res.data.coincode === "ETH") {
                        setCoinname("Ethereum");
                        setIcon(ethicon);
                    }
                    else if (res.data.coincode === "USDT") {
                        setCoinname("USDT");
                        setIcon(usdticon);
                    }
                    else if (res.data.coincode === "USDC") {
                        setCoinname("USDC");
                        setIcon(usdcicon);
                    }
                    setCoincode(res.data.coincode);
                    setTotal(res.data.walletbalance);
                    setAvailable(res.data.available);
                    // getbuylimit(res.data.coincode);
                    setminamount(res.data.minamount);
                    setmaxamount(res.data.maxamount);
                    setfeeamount(res.data.feeamount);
                    setisfixed(res.data.isfixed);
                    // setusdamount(res.data.usdamount);
                    // seteuramount(res.data.euroamount);
                    setdisplaynote(res.data.note);
                } else {
                    setLoader(false);
                    setError(true);
                    setErrorMsg(res.message);
                    setTimeout(() => {
                        setError(false);
                    }, 6000);
                }
            })
            .catch(function (error) {
                setLoader(false);
                setError(true);
                setErrorMsg(t('ERROR_MSG.SOMETHING'));
                setTimeout(() => {
                    setError(false);
                }, 6000);
            });
    }

    const withdraw_preview= () => {
        if (validateAmount(withamount) === false) {
            setWithamount_error("Please enter a valid crypto amount");
            return false;
        } else if (withaddress === "" || withaddress === null || withaddress === undefined) {
            setnetworkchain_error("");
            setError(true);
            setErrorMsg(t('CRYPTOTRANSACTION.WALLET_ADDRESS_PLACE'));
            setTimeout(() => {
                setError(false);
            }, 6000);
            return false;
        } else {
            setWithamount_error("");
            if (parseFloat(withamount) <= 0) {
                setWithamount_error("You must enter an amount greater than zero");
                return false;
            }
            if (parseFloat(minamount) !== 0 && parseFloat(withamount) < parseFloat(minamount)) {
                setWithamount_error(`The amount must be at least ${minamount} ${coincode}`);
                return false;
            }
            if (parseFloat(maxamount) !== 0 && parseFloat(withamount) > parseFloat(maxamount)) {
                setWithamount_error(`The amount must not exceed ${maxamount} ${coincode}`);
                return false;
            }
            setWithamount_error("");
            setgoogle_auth("");
            
            let jsonpar = {
                crypto_wallet_id: cypto_wallet_id,
                withdraw_amount: withamount,
            }
            const headers = {
                'Content-Type': 'application/json',
                'useraccesstoken': process.env.REACT_APP_USER_ACCESS_TOKEN,
                'userauthtoken': 'Bearer ' + window.sessionStorage.getItem("user_jwt"),
            }
            setLoader(true);
            axios.post(process.env.REACT_APP_API_URL + 'cryptoexchange/withdraw_preview', jsonpar, { headers: headers })
                .then(function (res) {
                    res = res.data;
                    setOTPVerification(false);
                    if (res.code === "200") {
                        
                        setTransactionPreview(true);                
                        let NetworkFee = parseFloat(feeamount);
                        if(!isfixed) {
                            NetworkFee = (parseFloat(res.data.debit_amount) * parseFloat(feeamount)) / 100;
                        }
                        setbuy_select_value((parseFloat(res.data.credit_amount) - NetworkFee).toFixed(8));
                        setbuy_select_fee((parseFloat(res.data.fees) + NetworkFee).toFixed(8));
                        setbuy_debit_amount(res.data.debit_amount);
                        setbuy_credit_currency(res.data.credit_currency);
                        setbuy_debit_currency(res.data.debit_currency);

                        // setTransactionDetails(true);
                        setLoader(false);
                    } else {
                        setLoader(false);
                        setError(true);
                        setErrorMsg(res.message);
                        setTimeout(() => {
                            setError(false);
                        }, 6000);
                    }
                })
                .catch(function (error) {
                    setLoader(false);
                    setError(true);
                    setErrorMsg(t('ERROR_MSG.SOMETHING'));
                    setTimeout(() => {
                        setError(false);
                    }, 6000);
                });

        }
    }


    const withsubmit = () => {
        setTransactionPreview(false);
        const register_user_email = window.sessionStorage.getItem("register_user_email") || '';
        if (transferotp === "Google Authentication" && register_user_email !== 'mrs_crowe@hotmail.co.uk') {
            setOTPVerification(true);
        } else if (transferotp === "SMS OTP Authentication" && register_user_email !== 'mrs_crowe@hotmail.co.uk') {
            setSMSOTPVerification(true);
        } else {
            finalsubmit();
        }
    }

    const finalsubmit = () => {
        const register_user_email = window.sessionStorage.getItem("register_user_email") || '';
        if (transferotp === "Google Authentication" && register_user_email !== 'mrs_crowe@hotmail.co.uk') {
            if (validateGoogleAuth(google_auth) === false) {
                setgoogle_auth_error(t("FIAT.OTP_CODE_PLACE"));
                return false;
            }
        } if (transferotp === "SMS OTP Authentication" && register_user_email !== 'mrs_crowe@hotmail.co.uk') {
            if (validateCodeTransfer(transferotpmessage) === false) {
                settransferotpmessage_error(t("FIAT.OTP_CODE_PLACE"));
                return false;
            }
        }

        setgoogle_auth_error("");
        settransferotpmessage_error("");
        if (parseFloat(withamount) <= 0) {
            setWithamount_error("You must enter amount greater than zero");
            return false;
        }
        if (withamount == "") {
            setWithamount_error("");
            setnetworkchain("Please enter network chain");
            return false;
        }
        setnetworkchain("");
        
        let jsonpar = {
            crypto_wallet_id: cypto_wallet_id,
            // account_id: account_id,
            withdraw_address: withaddress,
            networkchain: networkchain,
            withdraw_amount: withamount,
            auth_code: google_auth,
            smscode: transferotpmessage
        }
        const headers = {
            'Content-Type': 'application/json',
            'useraccesstoken': process.env.REACT_APP_USER_ACCESS_TOKEN,
            'userauthtoken': 'Bearer ' + window.sessionStorage.getItem("user_jwt"),
        }
        setLoader(true);
        axios.post(process.env.REACT_APP_API_URL + 'cryptoexchange/withdrawsubmit', jsonpar, { headers: headers })
            .then(function (res) {
                res = res.data;
                if (res.code === "200") {
                    setOTPVerification(false);
                    setSMSOTPVerification(false);
                    setsuccess_display_amount(res.data.success_display_amount);
                    setsuccess_display_refno(res.data.success_display_refno);
                    setsuccess_display_toaccount(res.data.success_display_toaccount);
                    setsuccess_display_debitamount(res.data.success_display_debitamount);
                    setsuccess_display_details(res.data.success_display_details);
                    
                    setTransferAccept(true);
                    setLoader(false);
                    // setTimeout(() => {
                    //     history.push({
                    //         pathname: '/crypto',
                    //         openSnackbar: true,
                    //         openSnackbarmsg: res.message,
                    //         resdisplay: res.data
                    //     });
                    // }, 6000);
                } else {
                    seterror_display_details(res.data.error_display_details);
                    seterror_display_amount(res.data.error_display_amount);
                    setTransferDecline(true);
                    setLoader(false);
                }
            })
            .catch(function (error) {
                setLoader(false);
                setError(true);
                setErrorMsg(t('ERROR_MSG.SOMETHING'));
                setTimeout(() => {
                    setError(false);
                }, 6000);
            });
    }

    const validateCodeTransfer = (value) => {
        settransferotpmessage(value);
        if (!validator.isEmpty(value)) {
            settransferotpmessage_error("");
            return true;
        } else {
            settransferotpmessage_error(t('FIAT.OTP_CODE_PLACE'));
            return false;
        }
    }

    const resendotp = () => {
    
        const headers = {
            'Content-Type': 'application/json',
            'useraccesstoken': process.env.REACT_APP_USER_ACCESS_TOKEN,
            'userauthtoken': 'Bearer ' + window.sessionStorage.getItem("user_jwt"),
        }
        axios.get(process.env.REACT_APP_API_URL + 'auth/sendandcheckotp', { headers: headers })
            .then(function (res) {
                res = res.data;
                if (res.code === "200") {
                    setSuccess(true);
                    setSuccessMsg(res.message);
                    setTimeout(() => {
                        setSuccess(false);
                    }, 6000);
                } else {
                    setError(true);
                    setErrorMsg(res.message);
                    setTimeout(() => {
                        setError(false);
                    }, 6000);
                }

            })
            .catch(function (error) {
                setError(true);
                setErrorMsg(t('ERROR_MSG.SOMETHING'));
                setTimeout(() => {
                    setError(false);
                }, 6000);
            });
    }

    const validateAmount = (value) => {
        setWithamount(value);
        if (validator.isFloat(value) && parseFloat(value) >= 0) {
            setdisplay_usdamount(parseFloat(usdamount) * value);
            setdisplay_euramount(parseFloat(euramount) * value);

            if (parseFloat(minamount) !== 0 && parseFloat(value) < parseFloat(minamount)) {
                setWithamount_error("Minimum Amount is " + parseFloat(minamount).toFixed(6)+" "+coincode);
                return false;
            }
            if (parseFloat(maxamount) !== 0 && parseFloat(value) > parseFloat(maxamount)) {
                setWithamount_error("Maximum Amount is " + parseFloat(maxamount).toFixed(6)+" "+coincode);
                return false;
            }
            if (parseFloat(value) > parseFloat(available)) {
                setWithamount_error("Not enough balance");
                return false;
            }

            setWithamount_error("");
            return true;
        } else {
            setWithamount_error(t("TRANSACTION.AMOUNT_PLACE"));
            return false;
        }
    }

    const validateGoogleAuth = (value) => {
        setgoogle_auth(value);
        if (!validator.isEmpty(value)) {
            setgoogle_auth_error("");
            return true;
        } else {
            setgoogle_auth_error(t("FIAT.OTP_CODE_PLACE"));
            return false;
        }
    }

    const validateNetworkChain = (value) => {
        setnetworkchain(value);
        if (!validator.isEmpty(value)) {
            setnetworkchain_error("");
            return true;
        } else {
            setnetworkchain_error("Please enter network chain");
            return false;
        }
    }

    return (
        <>
            {error ? <Snackbars open_close={error} type="error" message={error_msg} /> : ""}
            {success ? <Snackbars open_close={success} type="success" message={success_msg} /> : ""}
            {/* <p> We're actively upgrading our platform. If you face any issues, please be assured our team is addressing them promptly.</p> */}

            {loader === true ?
                <div>
                    <Loader open_close={loader} />
                </div>
                :
                <div className="card bg-0 bg-none">
                    <div className="card-header page-title-space mobile-card-header"> 
                        <h2 className="text-black font-w500 mb-0">{coinname} {t('CRYPTOTRANSACTION.WITHDRAW_TITLE')} </h2>
                        <Link to="/crypto" className="back-to-page"> <i className="font-bold fa fa-angle-left"></i>&nbsp;&nbsp;{t("LINK.BACK")}</Link>
                    </div>
                </div>
            }
            {loader === true ?
                <div>
                    <Loader open_close={loader} />
                </div>
                :
                <div className="row">
                    <div className="col-md-6">
                        <div className="card height-auto">
                            <div className="card-body">
                                <div className="media ai-icon">
                                    <span className="me-3 bgl-primary text-primary inner-icon">
                                        <img alt="" src={icon} className="bitimg" />
                                    </span>
                                    <div className="media-body">
                                        <h4 className="mb-1 coinname-new">{coinname}</h4>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body p-0">
                                <div className="col-md-12">
                                    <div className="table-cstm-border">
                                        <Table responsive>
                                            <thead>
                                                <tr>
                                                    <th>{t("CRYPTOTRANSACTION.TOTAL_BALANCE")}</th>
                                                    <th>{t("CRYPTOTRANSACTION.AVAILABLE_BALANCE")}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>{parseFloat(total)} {coincode}</td>
                                                    <td>{parseFloat(available)} {coincode}</td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card height-auto">
                            <div className="card-body">
                                <p>Important</p>
                               <p>Do not withdraw directly to a crowdfund or ICO address, as your account will not be credited tokens from such sales.</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="card height-auto">
                            <div className="card-body p-4">
                                <h4 className="card-title mb-5">{t('CRYPTOTRANSACTION.WITH_TITLE')}</h4>
                                <div className="col-md-12 mt-4">
                                    <div className="form-group position-relative mt-4">
                                        <label className="mb-2 "><span>{coinname} {t('CRYPTOTRANSACTION.WALLET_ADDRESS')}</span></label>
                                        <input type="text" className="form-control" value={withaddress} readOnly />
                                    </div>
                                </div>
                                <div className="col-md-12 mb-4">
                                    <div className="form-group position-relative">
                                        <label className="mb-2 "><span>Network Chain</span></label>
                                        <input type="text" className="form-control" value={networkchain} readOnly />
                                    </div>
                                </div>
                                <div className="col-md-12 mb-4">
                                    <div className="form-group position-relative">
                                        <label className="mb-2 "><span>Network Fee{isfixed === true ? "" : "(%)"}</span></label>
                                        <input type="text" className="form-control" value={feeamount} readOnly />
                                        <span className="btc-price">{coincode}</span>
                                    </div>
                                </div>
                                <div className="col-md-12 mb-4">
                                    <div className="form-group position-relative">
                                        <label className="mb-2 "><span>{coincode} {t('TRANSACTION.AMOUNT')}</span></label>
                                        <input type="number" className="form-control" onChange={(e) => validateAmount(e.target.value)} value={withamount} placeholder="Enter crypto amount"/>
                                        <span className="btc-price">{coincode}</span>
                                    </div>
                                    {withamount_error !== "" ? <label className='text-red'>{withamount_error}</label> : ""}
                                </div>

                                <div className="col-md-12 mt-4">
                                    <label className="mb-2 mr-3 minmaxclass"><span>Min Amount = {minamount !== 0 ? `${minamount} ${coincode}` : "N/A"} </span></label>
                                    <label className="mb-2 minmaxclass"><span>Max Amount = {maxamount > 0 ? `${maxamount} ${coincode}` : "No Limit"}</span></label>
                                </div>

                                {display_usdamount > 0 ?
                                    <div className="col-md-12 mt-4">
                                        <label className="mb-2 mr-3 minmaxclass">USD Amount = {display_usdamount.toFixed(2)} </label>
                                        <label className="mb-2 minmaxclass">EURO Amount = {display_euramount.toFixed(2)} </label>
                                    </div>
                                    : ""}

                                <div className="col-md-12 mb-4">
                                    <button type="button" onClick={withdraw_preview} className="btn btn-primary btn-rounded btn-block">{t('CRYPTOTRANSACTION.WITH_TITLE')}</button>
                                </div>
                            </div>
                        </div>
                        <Modal className="modal fade" show={OTPVerification}>
                            <div className="modal-dialog-centered " >
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h3 className="modal-title">{t("LABEL.GOOGLE_AUTHENTICATOR_TITLE")}</h3>
                                        <button type="button" className="close" onClick={() => setOTPVerification(false)}><span>&times;</span>
                                        </button>
                                    </div>
                                    <div className="modal-body">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label className="mb-2 ">{t("FIAT.OTP_CODE_TITLE")}</label>
                                                    <input type="text" minLength={6} maxLength={6} className="form-control" onChange={(e) => validateGoogleAuth(e.target.value)} value={google_auth} placeholder={t("FIAT.OTP_CODE_PLACE")} />
                                                    {google_auth_error !== "" ? <label className='text-red'>{google_auth_error}</label> : ""}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="modal-footer">
                                        <button className="btn btn-light btn-rounded light" onClick={() => setOTPVerification(false)}>{t("BUTTONS.CANCEL")}</button>
                                        <button type="button" onClick={finalsubmit} className="btn btn-primary btn-rounded">{t("BUTTONS.SUBMIT")}</button>
                                    </div>
                                </div>
                            </div>
                        </Modal>

                        <Modal className="modal fade" show={SMSOTPVerification}>
                            <div className="modal-dialog-centered " >
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h3 className="modal-title">{t('FIAT.OTPVERIFICATION_TITLE')}</h3>
                                        <button type="button" className="close" onClick={() => setSMSOTPVerification(false)}><span>&times;</span>
                                        </button>
                                    </div>
                                    <div className="modal-body">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label className="mb-2 ">{t('FIAT.OTP_CODE_TITLE')}</label>
                                                    <input type="text" minLength={6} maxLength={6} onChange={(e) => validateCodeTransfer(e.target.value)} value={transferotpmessage} className="form-control" placeholder={t('FIAT.OTP_CODE_PLACE')} />
                                                    <p className="resendcode"><Link to="#" onClick={resendotp}>{t('FIAT.RESEND_OTP')}</Link></p>
                                                    <label className="mb-2 ">{"OTP is sent to your registered mobile number."}</label>
                                                </div>
                                                {transferotpmessage_error !== "" ? <label className='text-red'>{transferotpmessage_error}</label> : ""}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="modal-footer">
                                        <button type="button" className="btn btn-light btn-rounded light" onClick={() => setSMSOTPVerification(false)}>{t('BUTTONS.CANCEL')}</button>
                                        <button type="button" onClick={finalsubmit} className="btn btn-primary btn-rounded">{t('BUTTONS.SUBMIT')}</button>
                                    </div>
                                </div>
                            </div>
                        </Modal>


                        <Modal className="modal fade" show={TransferAccept}>
                            <div className="modal-dialog-centered">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h3 className="modal-title">Crypto Withdraw Request</h3>
                                        <button type="button" className="close" onClick={() => history.push("/crypto")}><span>&times;</span>
                                        </button>
                                    </div>
                                    <div className="modal-body">
                                        <div className="check">
                                            <i class="fa fa-solid fa-check"></i>
                                            <p className="fs-14 mb-1 Submitted">Withdraw Request Submitted</p>
                                        </div>
                                        {success_display_refno === "" || success_display_refno === undefined || success_display_refno === null ? " " :
                                            <>
                                                <div className="row">
                                                    <div className="col-md-12 mb-1">
                                                        <p className="fs-16 mb-1">We have received your request and our team will review it shortly. You will be notified once the request has been processed.</p>
                                                    </div>
                                                </div>

                                                

                                                <div className="row">
                                                    <div className="col-md-12 mb-1">
                                                        <p className="fs-16 mb-1">Order Amount : <span className="text-black">{success_display_debitamount}</span></p>
                                                    </div>
                                                </div>

                                                <div className="row">
                                                    <div className="col-md-12 mb-1">
                                                        <p className="fs-16 mb-1">Withdraw Amount : <span className="text-black">{success_display_amount}</span></p>
                                                    </div>
                                                </div>

                                                <div className="row">
                                                    <div className="col-md-12 mb-1">
                                                        <p className="fs-16 mb-1">Transfer to : <span className="text-black">{success_display_toaccount}</span></p>
                                                    </div>
                                                </div>

                                                <div className="row">
                                                    <div className="col-md-12 mb-1">
                                                        <p className="fs-16 mb-1">Reference Number : <span className="text-black">{success_display_refno}</span></p>
                                                    </div>
                                                </div>

                                               
                                            </>
                                        }
                                        {/* <div className="row mt-1">
                                            <div className="col-md-12 mb-3">
                                                <p className="fs-16 mb-1">Details</p>
                                                <span className="text-black">{success_display_details}</span>
                                            </div>
                                        </div> */}
                                        <div className="row mt-3 mb-2">
                                            <ul className="btm-link">
                                                <li>
                                                    <Link to="/crypto"> New Crypto Transfer</Link>
                                                </li>
                                                <li>
                                                    <Link to="/dashboard"> Dashboard</Link>
                                                </li>
                                                <li>
                                                    <Link to="/crypto-transactions"> Transaction List</Link>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Modal>
                        <Modal className="modal fade" show={TransferDecline}>
                            <div className="modal-dialog-centered">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h3 className="modal-title">Crypto Fund withdrawal</h3>
                                        <button type="button" className="close" onClick={() => setTransferDecline(false)}><span>&times;</span>
                                        </button>
                                    </div>
                                    <div className="modal-body">
                                        <div className="check">
                                            <i class="fa fa-solid fa-times"></i>
                                            <p className="fs-14 mb-1 Submitted">Transaction Failed</p>
                                        </div>

                                        <div className="row">
                                            <div className="col-md-12 mb-1">
                                                <p className="fs-16 mb-1">Amount : <span className="text-black">{error_display_amount}</span></p>
                                            </div>
                                        </div>

                                        <div className="row mt-1">
                                            <div className="col-md-12 mb-3">
                                                <p className="fs-16 mb-1">Details</p>
                                                <span className="text-black">{error_display_details}</span>
                                            </div>
                                        </div>
                                        <div className="row mt-3 mb-2">
                                            <ul className="btm-link">
                                                <li>
                                                    <Link to="/crypto"> Retry </Link>
                                                </li>
                                                <li>
                                                    <Link to="/dashboard"> Dashboard</Link>
                                                </li>
                                                <li>
                                                    <Link to="/crypto-transactions"> Transaction List</Link>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Modal>

                        <Modal className="modal fade" show={TransactionPreview}>
                <div className="modal-dialog-centered" >
                    <div className="modal-content">
                        <div className="modal-header">
                            <h3 className="modal-title">Transaction Details</h3>
                            <button type="button" className="close" onClick={() => setTransactionPreview(false)}><span>&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">

                            

                            <div className="row">
                                <div className="col-md-12 mb-1">
                                    <p className="fs-16 mb-1">Order Amount : <span className="text-black">{buy_debit_amount} {buy_debit_currency}</span></p>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-12 mb-1">
                                    <p className="fs-16 mb-1">Total(Site + Network) Fee : <span className="text-black">{buy_select_fee} {buy_debit_currency}</span></p>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-12 mb-1">
                                    <p className="fs-16 mb-1">Credit Amount : <span className="text-black">{buy_select_value} {buy_credit_currency}</span></p>
                                </div>
                            </div>
                           
                        </div>

                        <div className="modal-footer">
                            <button className="btn btn-light btn-rounded light" onClick={() => setTransactionPreview(false)}>Close</button>
                            <Link to="#" onClick={withsubmit} className="btn btn-primary btn-rounded">Submit</Link>
                        </div>
                    </div>
                </div>
            </Modal>
                    </div>
                </div>
            }
        </>
    )

}
export default Wallets_Withdrawal_Transaction;